import { ref, computed } from 'vue';
import type { PassengersData } from '@aviata/booking-data';
import type {
  StructuredAncillaries,
  PassengersAncillaryState,
} from '@aviata/ancillary-fns';
import type { flightEntity } from 'freedom-shared';

import { mappedPassengersLib } from './lib';
import type { PassengerWithBaggage } from './types';

const useBaggageData = () => {
  const data = ref<
    | { passengers: PassengerWithBaggage[]; hasSelectedBaggage: boolean }
    | undefined
  >();
  const totalPrice = computed(() => {
    if (data.value?.hasSelectedBaggage && data.value?.passengers) {
      return mappedPassengersLib.getTotalPrice(data.value?.passengers);
    }
    return null;
  });
  const totalOriginalPrice = computed(() => {
    if (data.value?.hasSelectedBaggage && data.value?.passengers) {
      return mappedPassengersLib.getTotalOriginalPrice(data.value?.passengers);
    }
    return null;
  });

  const init = (
    passengers: PassengersData,
    ancillariesList: Partial<StructuredAncillaries>,
    flights: flightEntity.types.MappedFlight[],
    ancillariesState?: PassengersAncillaryState,
  ) => {
    data.value = mappedPassengersLib.getPassengersWithAvailableBaggages(
      passengers,
      ancillariesList,
      flights,
      ancillariesState,
    );
  };

  const updateState = (state: {
    passengers: PassengerWithBaggage[];
    hasSelectedBaggage: boolean;
  }) => {
    data.value = state;
  };

  return {
    data,
    totalPrice,
    totalOriginalPrice,
    updateState,
    init,
  };
};

export const mappedPassengersModel = {
  useBaggageData,
};
